import { render, staticRenderFns } from "./BusinessInfo.vue?vue&type=template&id=e65f5f76&scoped=true"
import script from "./BusinessInfo.vue?vue&type=script&lang=js"
export * from "./BusinessInfo.vue?vue&type=script&lang=js"
import style0 from "./BusinessInfo.vue?vue&type=style&index=0&id=e65f5f76&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e65f5f76",
  null
  
)

export default component.exports